// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jFPZX","textarea":"styles_textarea__2tmrK"};